/* Altera todos os links de coleções para links com parametro de disponibilidade */
// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll("a[href*='/collections/']").forEach(link => {
//         let url = new URL(link.href, window.location.origin);
//         let params = url.searchParams;

//         if (!params.has('filter.v.availability') || params.get('filter.v.availability') !== '1') {
//             params.set('filter.v.availability', '1'); // Adiciona ou substitui o parâmetro
//             link.href = url.toString(); // Atualiza o link
//         }
//     });
// });

let slideDiferenciais,
    sliderHome,
    stories,
    sliderMenuCollection;

$('.product-form__label').on('click', function(){
  $(this).closest('.product-form__input').removeClass('block-swatch classe-erro');
})

if($('.slider-color').length){ 
  var cores = new Swiper(".slider-color", {
    slidesPerView: "auto",
    spaceBetween: 5,
    slidesPerGroup: 6,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1024: {
        slidesPerView: "auto",
        slidesPerGroup: 6,
        spaceBetween: 5
      }
    }
  });
}

if($('.compre-look-products-slider').length){ 
  var cores = new Swiper(".compre-look-products-slider", {
    slidesPerView: "auto",
    spaceBetween: 0,
    slidesPerGroup: 6,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1024: {
        slidesPerView: "auto",
        slidesPerGroup: 6,
        spaceBetween: 0
      }
    }
  });
}

if($('.swiper-calcas').length){ 
  var swiperCalcas = new Swiper('.swiper-calcas', {
    slidesPerView: 2.5,
    centerInsufficientSlides: true,
    spaceBetween: 10,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        320: {
            slidesPerView: 2.5,
            spaceBetween: 10
        },
        480: {
            slidesPerView: 2.5,
            spaceBetween: 10
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 10
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 10
        },
        1200: {
            slidesPerView: 5,
            spaceBetween: 10
        },
        1400: {
            slidesPerView: 6,
            spaceBetween: 10
        }
    }
});
}

if($(window).width() <= 767){
  stories?.destroy(true, true);
  slideDiferenciais?.destroy(true, true);
  $('.slider-collection-menu.swiper-initialized').each(function() {
    this.swiper.destroy(true, true);
  });
}

$( window ).on( "resize", function() {
  if($(window).width() <= 767){
    stories?.destroy(true, true);
    slideDiferenciais?.destroy(true, true);
    $('.slider-collection-menu.swiper-initialized').each(function() {
      this.swiper.destroy(true, true);
    });
  }else{
    slidesDesktop();
  }
});

// $('.menu-lv-item menu-lv-1.has-megamenu').click(function(){
//   setTimeout(function(){
//     if($(window).width() <= 767){
//       $('.slider-collection-menu.swiper-initialized').each(function() {
//         this.swiper.destroy(true, true);
//       });
//     }
//   }, 100)
// })

$('.menu-lv-item.menu-lv-1').each(function() {
    var $this = $(this); // Armazena a referência atual do jQuery
    var largura = $this.outerWidth(); // Captura a largura do elemento
    var estiloAtual = $this.attr('style') || ''; // Pega o estilo atual, se houver
    $this.attr('style', estiloAtual + (estiloAtual ? '; ' : '') + '--width: ' + largura + 'px'); // Atualiza o atributo style
});

let navTamanhoGrid;
let navModelagemGrid;
let colorList;

window.sliderNavGrid = function(){
  // navTamanhoGrid = new Swiper(".swiper-tamanho-list:not(.swiper-initialized)", {
  //     slidesPerView: "auto",
  //     slidesPerGroup: 8,
  //     spaceBetween: 0,
  //     navigation: {
  //       nextEl: ".swiper-button-next",
  //       prevEl: ".swiper-button-prev",
  //     },
  //     on: {
  //       init: function () {
  //         window.checkSlidesForNavigation(this);
  //       },
  //       resize: function () {
  //         window.checkSlidesForNavigation(this);
  //       }
  //     }
  //   });
  // navModelagemGrid = new Swiper(".swiper-modelagem-list:not(.swiper-initialized)", {
  //     slidesPerView: "auto",
  //     slidesPerGroup: 6,
  //     spaceBetween: 0,
  //     navigation: {
  //       nextEl: ".swiper-button-next",
  //       prevEl: ".swiper-button-prev",
  //     },
  //     on: {
  //       init: function () {
  //         window.checkSlidesForNavigation(this);
  //       },
  //       resize: function () {
  //         window.checkSlidesForNavigation(this);
  //       }
  //     }
  //   })  
  // colorList = new Swiper(".color-list-swiper", {
  //   slidesPerView: "auto",
  //   spaceBetween: 4,
  //   slidesPerGroup: 6,
  //   loop: false,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   }
  // });

  // updateArrowVisibility();
}

window.checkSlidesForNavigation = function(swiper) {
  // let totalSlideWidth = swiper.slides.reduce((acc, slide) => acc + slide.offsetWidth + swiper.params.spaceBetween, 0) - swiper.params.spaceBetween;

  // if (totalSlideWidth > swiper.width) {
  //     swiper.el.classList.add("swiper-has-enough-slides");
  // } else {
  //     swiper.el.classList.remove("swiper-has-enough-slides");
  // }
}

window.sliderNavGrid();

$(document).on('click', '[option-check-variant]', function(){
  console.log("Teste")
  let clickedOption = $(this);
  let containerGridVariants = clickedOption.closest('.variants-container-grid');
  let atualSelectorVariant = clickedOption.closest('.variant-selector-grid');
  let value = clickedOption.attr('option-check-variant');
  let json;
  let option = atualSelectorVariant.attr('optionIndex');
  let url = containerGridVariants.attr('url-product')+'?view=json_quick_view';

  $(this).closest('.card').find('.quick-add-bubble')?.attr('data-product-handle', $(this).attr('data-handle'));
  $(this).closest('.card').find('[href]')?.attr('href', $(this).attr('url-product'));

  $.get(url, function(data) {
    let html = $('<div></div>').html(data);
    html = html.find('[product-json]').html();
    json = JSON.parse(html);

    var result = json.filter(function(item) {
      return item[option] === value;
    });
    
    if(atualSelectorVariant.next('.variant-selector-grid').length > 0) {

      nextOptionsList = atualSelectorVariant.next('.variant-selector-grid');
      let maxSlides = nextOptionsList.attr('maxSlider');
      let swiperItem = nextOptionsList.find('.swiper');
      let option = nextOptionsList.attr('optionIndex');

      var newOptions = result.map(function(item) {
        return item[option];
      });

      
      swiperItem.each(function() {
          if (this.swiper) {
              this.swiper?.destroy(true, true);
          }
      });

      let swiperWrapper = nextOptionsList.find('.swiper-wrapper');

      swiperWrapper.empty();

      swiperWrapper.append('<div class="swiper-slide"><button return-options-variant class="return-option"><svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none"> <path d="M4 10L3.64645 10.3536L3.29289 10L3.64645 9.64645L4 10ZM20.5 18C20.5 18.2761 20.2761 18.5 20 18.5C19.7239 18.5 19.5 18.2761 19.5 18L20.5 18ZM8.64645 15.3536L3.64645 10.3536L4.35355 9.64645L9.35355 14.6464L8.64645 15.3536ZM3.64645 9.64645L8.64645 4.64645L9.35355 5.35355L4.35355 10.3536L3.64645 9.64645ZM4 9.5L14 9.5L14 10.5L4 10.5L4 9.5ZM20.5 16L20.5 18L19.5 18L19.5 16L20.5 16ZM14 9.5C17.5898 9.5 20.5 12.4101 20.5 16L19.5 16C19.5 12.9624 17.0376 10.5 14 10.5L14 9.5Z" fill="#222222"/> </svg></button></div>');

      $.each(result, function(index, variant) {
          var slide = $('<div class="swiper-slide"></div>');

          if (variant.option2) {
            
            if(variant.available === true){
              var button = $('<button></button>')
                  .attr('option-check-variant', variant[option])
                  .attr('variant-id', variant.id)
                  .text(variant[option]);
            }else{
                var button = $('<button></button>')
                    .attr('option-check-variant', variant[option])
                    .attr('variant-id', variant.id)
                    .attr('disabled', true)
                    .text(variant[option]);
            }
            slide.append(button);
          }
        
          swiperWrapper.append(slide);
      });

      window.sliderNavGrid();

      atualSelectorVariant.hide();
      nextOptionsList.show();

    }else{
      let variantId = parseInt(clickedOption.attr('variant-id'));
      let formData = {
        'items': [{
         'id': variantId,
         'quantity': 1
         }]
       };

       fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
        Shopify.getCart((cart) => {
          window.updateCart(cart);
          document.body.classList.add('cart-sidebar-show');
        })
       })
       .catch((error) => {
         console.error('Error:', error);
       });
    }
  })
  
})
$(document).on('click', '[fast-buy-grid-unic]', function(){
  let variantId = parseInt($(this).attr('fast-buy-grid-unic'));
  let formData = {
    'items': [{
     'id': variantId,
     'quantity': 1
     }]
   };
  
   fetch(window.Shopify.routes.root + 'cart/add.js', {
     method: 'POST',
     headers: {
       'Content-Type': 'application/json'
     },
     body: JSON.stringify(formData)
   })
   .then(response => {
    Shopify.getCart((cart) => {
      window.updateCart(cart);
      document.body.classList.add('cart-sidebar-show');
    })
   })
   .catch((error) => {
     console.error('Error:', error);
   });
})
$(document).on('click', '[return-options-variant]', function(){
  let atualSelectorVariant = $(this).closest('.variant-selector-grid');
  atualSelectorVariant.hide();
  atualSelectorVariant.prev('.variant-selector-grid').show();
})
$(document).on('click', '[data-image-feature]:not(.active)', function(){
  let cardItem = $(this);
  let handle = $(this).attr('data-handle');
  let url = $(this).attr('url-product')+'?view=json_quick_view';
  
  let containerColor = $(this).closest('.colors-list-thumbs');
  containerColor.find('.thumb-color-meta.active').removeClass('active');
  $(this).addClass('active');
  
  let colorlist = cardItem.closest('.card').find('.colors-list-thumbs').html();

  cardItem.closest('.card').find('.colors-list-thumbs').addClass('block-swatch');

  let ajaxSearch = `/products/${handle}?view=quick_item_ajax`;
  $.get(ajaxSearch, function(data) {
    let html = $('<div></div>').html(data);
    let newproduct = html.find('.product-item');

    $.each(cardItem.closest('.product-item').attributes, function() {
      cardItem.closest('.product-item').removeAttr(this.name);
    });
    
    $.each(newproduct.attributes, function() {
      cardItem.closest('.product-item').attr(this.name, this.value);
    });
    
    cardItem.closest('.card').find('.card-product').html(newproduct.find('.card-product').html());
    cardItem.closest('.card').find('.card-information__wrapper').html(newproduct.find('.card-information__wrapper').html());
    cardItem.closest('.card').find('.variants-popup-form').html(newproduct.find('.variants-popup-form').html());

  }).done(function() {
    window.sliderNavGrid?.();
    window.updateSlideGridProduct?.();
    cardItem.closest('.card').find('.colors-list-thumbs').removeClass('block-swatch');
  })
});

// Seleciona o elemento do formulário
var formElement = document.querySelector('.product-form.check-selected-variant form');

// Verifica se o elemento existe antes de adicionar o ouvinte de evento
if (formElement) {
    formElement.addEventListener('submit', function(event) {
        // Previne o envio imediato do formulário
        event.preventDefault();

        // Flag para controlar se o formulário deve ser enviado
        let shouldSubmit = true;

        // Seleciona todos os inputs do formulário
        const inputs = document.querySelectorAll('.product-form__input');

        // Percorre cada input para verificar a presença da classe '.block-swatch'
        inputs.forEach(input => {
            if (input.classList.contains('block-swatch')) {
                // Adiciona uma classe de erro se a classe '.block-swatch' for encontrada
                input.classList.add('classe-erro');
                shouldSubmit = false; // Marca o formulário para não ser enviado
            }
        });

        // Se nenhum elemento com '.block-swatch' foi encontrado, o formulário pode ser enviado
        if (shouldSubmit) {
            this.submit(); // Submete o formulário
        } else {
            // Aqui você pode adicionar qualquer lógica adicional para quando o formulário não puder ser enviado
            console.log('Um ou mais campos obrigatórios precisam ser selecionados.');
        }
    });
} else {
    console.log('O formulário especificado não foi encontrado.');
}

function updateArrowVisibility() {
    document.querySelectorAll('.container-colorlist').forEach(function(container) {
        var colorlist = container.querySelector('.colors-list-thumbs');
        var arrow = container.querySelector('.arrow');

        // Calcula a largura total dos elementos .color
        var totalWidth = 0;
        colorlist.querySelectorAll('.thumb-color-meta').forEach(function(color) {
            totalWidth += color.offsetWidth + parseFloat(window.getComputedStyle(color).marginRight);
        });

        // Compara com a largura do container .colorlist
        if (totalWidth > colorlist.offsetWidth) {
            arrow.style.display = 'block'; // Mostra a seta se o conteúdo exceder o container
        } else {
            arrow.style.display = 'none'; // Oculta a seta se o conteúdo não exceder
        }
    });
}

updateArrowVisibility();

document.addEventListener('click', function(e) {
  // Verifica se o clique foi em um elemento .arrow
  if (e.target.classList.contains('arrow')) {
      var container = e.target.closest('.container-colorlist');
      if (container) {
          var colorlist = container.querySelector('.colors-list-thumbs');
          var isAtStart = colorlist.scrollLeft === 0;

          if (isAtStart) {
              // Rola para o fim
              colorlist.scrollLeft = colorlist.scrollWidth;
              e.target.innerHTML = `<svg class="icon-arrow-back reverse" width="16" height="11" viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none"><path d="M5.5 15.5002C5.75781 15.5002 5.92969 15.4169 6.10156 15.2502L11 10.5002L9.79687 9.33356L6.35938 12.6669L6.35938 0H4.64063L4.64062 12.6669L1.20312 9.33356L0 10.5002L4.89844 15.2502C5.07031 15.4169 5.24219 15.5002 5.5 15.5002Z" transform="translate(16.0002) rotate(90)" fill="currentColor"></path></svg>`; // Muda o texto da seta
          } else {
              // Rola para o início
              colorlist.scrollLeft = 0;
              e.target.innerHTML = `<svg class="icon-arrow-back" width="16" height="11" viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none"><path d="M5.5 15.5002C5.75781 15.5002 5.92969 15.4169 6.10156 15.2502L11 10.5002L9.79687 9.33356L6.35938 12.6669L6.35938 0H4.64063L4.64062 12.6669L1.20312 9.33356L0 10.5002L4.89844 15.2502C5.07031 15.4169 5.24219 15.5002 5.5 15.5002Z" transform="translate(16.0002) rotate(90)" fill="currentColor"></path></svg>`; // Muda o texto da seta para a direção inicial
          }
      }
  }
});

// UPSELL Carrinho
window.upsellSliderInit = function(){
  var upsellCartSlider = new Swiper(".recommend-slider", {
    slidesPerView: "auto",
    spaceBetween: 15,
    slidesPerGroup: 3,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true
    }
  });
}
function beforeSend() {
  $('#dropdown-cart').addClass('updating-cart');
}
function afterSend() {
  $('#dropdown-cart').removeClass('updating-cart');
}
$(document).on('submit', '.upsell-form', function(e) {
  e.preventDefault();

  const formData = new FormData(this);
  const serializedData = {};
  formData.forEach((value, key) => {
    serializedData[key] = value;
  });
  const jsonData = JSON.stringify(serializedData);

  // URL da API da Shopify para adicionar um item ao carrinho
  const addToCartUrl = window.Shopify.routes.root + 'cart/add.js';

  // Opções da requisição
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: jsonData,
  };

  beforeSend(); // Ação "before send" antes da requisição

  // Faz a requisição usando fetch com ação "before send" e "after send"
  fetch(addToCartUrl, requestOptions)
    .then((response) => {
      afterSend(); // Ação "after send" após a conclusão da requisição

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui
      window.updateCart();
    })
    .catch((error) => {
      // Houve um erro na requisição, você pode tratar o erro aqui
      console.error('Error:', error);
    });
});
$(document).on('change', '.variants-product-selects select', function() {
  var $currentSelect = $(this);
  var $nextSelect = $currentSelect.closest('.variants-product-selects').find('select').eq($currentSelect.index() + 1);
  var productData = JSON.parse($currentSelect.closest('.infoProduct').find('[data-json-product]').text());

  const availableVariants = productData.filter(variant => variant.title.includes($currentSelect.val()) && variant.available);

  if ($nextSelect.length) {
    $currentSelect.closest('.infoProduct').find('.recommend-btn-add').prop('disabled', true);
    nextSelectName = $nextSelect.data('name');
    $nextSelect.html(`<option disabled="" selected="">${nextSelectName}</option>`);
    const nextSelectIndex = $nextSelect.data('index');
    availableVariants.forEach(variant => {
      $nextSelect.append(`<option value="${variant[nextSelectIndex]}">${variant[nextSelectIndex]}</option>`)
    })
  }
  
  if ($nextSelect.length && $nextSelect.is(':hidden')) {
      $nextSelect.show();
  } else if (!$nextSelect.length) {
      var selectedOptions = $currentSelect.closest('.variants-product-selects').find('select').map(function() { return $(this).val(); }).get();
      var productData = JSON.parse($currentSelect.closest('.infoProduct').find('[data-json-product]').text());
      
      var matchingVariant = productData.find(function(variant) {
          return selectedOptions.every(function(option, index) {
              return variant.options[index] === option;
          });
      });

      if (matchingVariant && matchingVariant.available) {
          $currentSelect.closest('.infoProduct').find('.variantIdAddCart').val(matchingVariant.id);
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').prop('disabled', false);
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').val('ADICIONAR');
      } else {
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').prop('disabled', true);
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').val('ESGOTADO');
          console.log('Produto esgotado');
      }
  }

  var container = $('.halo-cart-sidebar').find('.previewCart');
  var scrollTo = $('.halo-cart-sidebar').find('.recommend-container');
  
  // A posição de rolagem final é a posição do topo do .recommend-container mais sua altura
  var scrollPosition = scrollTo.offset().top + scrollTo.outerHeight() + container.scrollTop() - container.position().top;
  
  // Realiza a rolagem
  container.animate({
      scrollTop: scrollPosition
  }, 1000); // 1000 milissegundos para a animação de rolagem
});

document.addEventListener("DOMContentLoaded", function () {
    // Seleciona todos os vídeos com a classe 'lazyload-video'
    const lazyVideos = document.querySelectorAll(".lazyload-video");

    lazyVideos.forEach(video => {
        // Seleciona todas as fontes dentro do vídeo
        const sources = video.querySelectorAll("source");

        sources.forEach(source => {
            if (source.dataset.src) {
                // Move o 'data-src' para 'src'
                source.src = source.dataset.src;
                source.removeAttribute("data-src");
            }
        });

        // Após mudar as fontes, carrega o vídeo para aplicar a mudança
        video.load();

        // Muda a classe para 'lazyloaded-video'
        video.classList.remove("lazyload-video");
        video.classList.add("lazyloaded-video");
    });
});


